import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-video-call-ended',
    templateUrl: './video-call-ended.component.html',
    styleUrls: ['./video-call-ended.component.scss'],
    standalone: false
})
export class VideoCallEndedComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private router : Router, private dialog:MatDialog) { }
  endId : any;
  ngOnInit(): void {
    this.activatedRoute.params.subscribe((p) => {
      this.endId = p['id']
    })
    // window.close();
    this.dialog.closeAll();
  }
  routeToDashBoard(){
    this.router.navigate(['/start-meeting'])
  }

}
